import Meta from '../../components/Meta'
import { ChatBox } from 'components/Chatbot/ChatBox'
import { useChatBot } from 'hooks/selectors/chatbots/useChatbot'

export default function ChatbotPage({ chatbot_id }) {
  useChatBot({ id: chatbot_id })

  return (
    <>
      <Meta
        title="Outcast"
        description="Outcast is a platform that helps you build AI chatbots that are trained on your data."
      />
      <ChatBox isIframed={true} />
    </>
  )
}

export async function getServerSideProps(context) {
  const { params } = context
  const { id } = params

  return {
    props: {
      chatbot_id: id,
    },
  }
}
